// Luật "dòng bán được" của đơn: đơn hợp lệ để tạo/xác nhận khi có ÍT NHẤT 1
// sản phẩm HOẶC 1 vật tư có đơn giá. Cho phép "đơn chỉ vật tư" (0 sản phẩm).
// Tách hàm thuần để unit-test và dùng chung ở form.

export interface SellableMaterialLine {
    unit_price: number
    quantity: number
}

/**
 * orderHasSellableLine — true khi đơn có ≥1 sản phẩm HOẶC ≥1 vật tư có đơn giá
 * (unit_price > 0 và quantity > 0). Dùng thay cho ràng buộc "phải có sản phẩm".
 */
export function orderHasSellableLine(
    items: readonly unknown[],
    materials: readonly SellableMaterialLine[],
): boolean {
    if (items.length > 0) return true
    return materials.some((mtl) => mtl.unit_price > 0 && mtl.quantity > 0)
}
